// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080604/js/" + chunkId + "." + {"44":"ae1e207b","225":"66039c16","481":"fa0fd3f5","486":"e2adfb85","770":"3324311e"}[chunkId] + ".0.6845371336093926.chunk.js";
};